// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
// @ commons
const OKSelect = require('components/commons/OKSelect/OKSelect');
// @ components
const InsuranceRequestPostalCodeInput = require('../../insuranceRequestPostalCodeInput/insuranceRequestPostalCodeInput');
// @ constants
const { EVENTS_INSURANCE_HOME } = require('../../../insuranceConstants/insuranceRequestTags');
const {
    LENGTH_POSTAL_CODE,
} = require('../../../insuranceConstants/insuranceRequestHome');
const {
    SECOND_STEP,
    THIRD_STEP,
    FOURTH_STEP,
} = require('constants/index');

class InsuranceRequestPostalCodePopulation extends React.Component {

    constructor(props) {
        super(props);

        this.handleChangePostalCode = this.handleChangePostalCode.bind(this);
        this.handleChangePostalCodeWithTooltip = this.handleChangePostalCodeWithTooltip.bind(this);
        this.handlePopulationChange = this.handlePopulationChange.bind(this);
        this.handlePostalCodeErrorMessage = this.handlePostalCodeErrorMessage.bind(this);
    }

    componentDidMount() {
        const {
            clearPostalCodeError,
            getPopulationData,
            immInsuranceWizardStep,
        } = this.props;

        clearPostalCodeError();

        const postalCode = immInsuranceWizardStep.get('postalCode');
        const populationOptions = immInsuranceWizardStep.get('populationOptions');
        if (postalCode.length === LENGTH_POSTAL_CODE && !populationOptions.size) {
            getPopulationData(postalCode);
        }
    }

    componentDidUpdate(prevProps) {
        const {
            changeErrorPostalCode,
            disablePostalCode,
            getPopulationData,
            immInsuranceWizardStep,
            isPostAppraisal,
            setData,
        } = this.props;

        const prevPostalCode = prevProps.immInsuranceWizardStep.get('postalCode');
        const postalCode = immInsuranceWizardStep.get('postalCode');
        const populationOptions = immInsuranceWizardStep.get('populationOptions');
        if (prevPostalCode !== postalCode && postalCode.length === LENGTH_POSTAL_CODE && !populationOptions.size) {
            getPopulationData(postalCode, true);
        }
        if (isPostAppraisal) {
            changeErrorPostalCode();
        }

        if (populationOptions.size > 0) {
            const populationValue = immInsuranceWizardStep.get('populationValue');
            const population = this.searchPopulationValueFromLabel();

            if (disablePostalCode && populationValue === null && (population === null || typeof population === 'undefined')) {
                setData(SECOND_STEP, {
                    population: null,
                })
            }
        }
    }

    handleChangePostalCodeWithTooltip(value) {
        const { getPopulationData } = this.props;
        this.handleChange('postalCode', value);
        getPopulationData(value);
    }

    handleChange(key, value) {
        const { recordEvent, saveAndRequestRecommendation } = this.props;

        if (key === 'propertyUsage' || key === 'propertyType') {
            const event = key === 'propertyUsage' ?
                EVENTS_INSURANCE_HOME.STEP_2_PROPERTY_USAGE_CHANGE :
                EVENTS_INSURANCE_HOME.STEP_2_PROPERTY_TYPE_CHANGE;
            recordEvent(event, value);
        }

        saveAndRequestRecommendation({ [key]: value });
    }

    handlePostalCodeErrorMessage(postalCode) {
        const requiredFieldText = formatText('common-requiredField');
        const invalidInputText = formatText('insuranceRequestHome-postalCodeErrorMessage');
        const postalCodeErrorMessage = !postalCode.length ? requiredFieldText : invalidInputText;

        return postalCodeErrorMessage
    }

    handleChangePostalCode(evt) {
        const { changeErrorPostalCode, getPopulationData, setData } = this.props;
        const postalCode = evt.target.value;

        setData(SECOND_STEP, {
            population: null,
            populationError: false,
            populationLabel: '',
            populationOptions: [],
            populationValue: null,
            postalCode,
            postalCodeIsDirty: true,
        });
        if (postalCode.length === LENGTH_POSTAL_CODE) {
            getPopulationData(postalCode);
            setData(FOURTH_STEP, {
                road: '',
                number: '',
                additionalInfo: '',
                population: '',
                roadType: '',
                roadTypeName: '',
                provinceId: '',
            });
        }
        changeErrorPostalCode();
    }

    handlePopulationChange(population) {
        const {
            changeErrorPopulation,
            immInsuranceWizardStep,
            saveAndRequestRecommendation,
            setData,
        } = this.props;
        const finalLabel = !!population ? population.label : immInsuranceWizardStep.get('populationLabel');
        const finalValue = !!population ? population.value : immInsuranceWizardStep.get('populationValue');
        saveAndRequestRecommendation(
            {
                populationIsDirty: true,
                populationLabel: finalLabel,
                populationValue: finalValue,
            }
        );
        setData(FOURTH_STEP, {
            population: finalLabel,
        });
        setData(THIRD_STEP, {
            population: finalLabel,
        });
        changeErrorPopulation();
    }

    buildPostalCode(postalCode, postalCodeInputError, isPostAppraisal) {
        const {
            changeErrorPostalCode,
            disablePostalCode,
         } = this.props;
        return (
            <div className="col-md-4 col-sm-12">
                <InsuranceRequestPostalCodeInput
                    value={postalCode}
                    onChangeInput={this.handleChangePostalCode}
                    onBlurInput={changeErrorPostalCode}
                    onSelect={location => this.handleChangePostalCodeWithTooltip(location.postalCode)}
                    inputError={postalCodeInputError}
                    inputErrorMessage={this.handlePostalCodeErrorMessage(postalCode)}
                    offset={[0, -15]}
                    isPostAppraisal={isPostAppraisal}
                    disablePostalCode={disablePostalCode}
                />
            </div>
        );
    }

    searchPopulationValueFromLabel() {
        const { immInsuranceWizardStep } = this.props;
        const populationLabel = immInsuranceWizardStep.get('population');
        const populationOptions = immInsuranceWizardStep.get('populationOptions');

        const population = populationOptions.filter(option => {
            return option.get('label').toUpperCase() === populationLabel;
        });
        return population.getIn([0, 'value']);
    }

    buildPopulation(immInsuranceWizardStep, populationDisable) {
        const {
            changeErrorPopulation,
            injectedTooltipText,
            populationClassName,
            tooltipText,
        } = this.props;

        const populationValue = immInsuranceWizardStep.get('populationValue') || this.searchPopulationValueFromLabel();
        const populationOptions = immInsuranceWizardStep.get('populationOptions');
        const populationError = immInsuranceWizardStep.get('populationError');
        const roadTypeErrorMessage = formatText('insuranceRequestHome-requiredFieldError');

        const titlePopulation = formatText('insuranceRequestHome-insuranceRequestHome_step2Population');
        const placeHolderPopulation = formatText('insuranceRequestHome-insuranceRequestHome_selectPopulation');
        const injectedValue = !!injectedTooltipText ? formatText(injectedTooltipText) : formatText('insuranceRequestHome-openbankInsurancesPhone');

        const tooltipContentPopulation = (
            <FormattedText
                value={tooltipText}
                injectedStrings={[injectedValue]}
            />
        );

        return (
            <div className={populationClassName}>
                <OKSelect
                    label={titlePopulation}
                    placeholder={placeHolderPopulation}
                    name="populationStep2Select"
                    options={populationOptions.toJS()}
                    value={populationValue}
                    onFocus={changeErrorPopulation}
                    errorState={!populationDisable && populationError}
                    errorMessage={roadTypeErrorMessage}
                    onChange={po => this.handlePopulationChange(po)}
                    tooltipContent={tooltipContentPopulation}
                    disabled={populationDisable}
                />
            </div>
        );
    }

    render() {
        const {
            immInsuranceWizardStep,
            isPostAppraisal,
        } = this.props;

        const postalCode = immInsuranceWizardStep.get('postalCode');
        const populationDisable = immInsuranceWizardStep.get('isFetchingSelectPopulation') ||
            !immInsuranceWizardStep.get('populationOptions').size;
        const postalCodeError = immInsuranceWizardStep.get('postalCodeError') &&
            !immInsuranceWizardStep.get('isFetchingSelectPopulation');

        const postalCodeComponent = this.buildPostalCode(postalCode, postalCodeError, isPostAppraisal);
        const populationComponent = this.buildPopulation(immInsuranceWizardStep, populationDisable);

        return (
            <React.Fragment>
                {postalCodeComponent}
                {populationComponent}
            </React.Fragment>
        );
    }

}

InsuranceRequestPostalCodePopulation.propTypes = {
    changeErrorPopulation: PropTypes.func.isRequired,
    changeErrorPostalCode: PropTypes.func.isRequired,
    clearPostalCodeError: PropTypes.func.isRequired,
    disablePostalCode: PropTypes.bool,
    getPopulationData: PropTypes.func.isRequired,
    immInsuranceWizardStep: PropTypes.object.isRequired,
    injectedTooltipText: PropTypes.array,
    isPostAppraisal: PropTypes.bool,
    populationClassName: PropTypes.string,
    recordEvent: PropTypes.func.isRequired,
    saveAndRequestRecommendation: PropTypes.func.isRequired,
    setData: PropTypes.func.isRequired,
    tooltipText: PropTypes.string.isRequired,
};

InsuranceRequestPostalCodePopulation.defaultProps = {
    disablePostalCode: false,
    populationClassName: 'col-xs-12 col-md-8',
    tooltipText: 'insuranceRequestHome-insuranceRequestHome_mesageTooltipPopulation',
};

module.exports = InsuranceRequestPostalCodePopulation;
